import Obstacle from "./obstacle";
import * as THREE from "three";
import {Vector3} from "three";
import GameConfig from "../config";
import Gate from "./gate";

export default class GateManager {
    static init({scene, blueprints}){
        this.scene = scene;
        this.blueprints = blueprints;

        const initialElements = 3;
        this.gateDistance = 20;
        this.spawnDistance = 20;
        this.offset = 52.5;

        this.skillGates = [];
        for(let i = 1; i < initialElements; i++){
            this.lastElementZ = this.offset + i * this.gateDistance;
            if(Math.random() > 0.25) continue;
            const skillGate = this.spawnGate(this.lastElementZ);
            skillGate.moveTo(new Vector3(0, 0, this.lastElementZ))
            this.skillGates.push(skillGate);
        }
        this.lastElementZ += this.gateDistance;
    }

    static spawnGate(z){
        return this.createSkillGate({
            blueprints: this.blueprints,
            position: new Vector3(0,0, z)
        });
    }

    static moveZ(amount){
        this.spawnDistance += amount;
        if(this.spawnDistance <= this.gateDistance){
            const overflow = -this.spawnDistance;
            this.spawnDistance = this.gateDistance - overflow;
            if(Math.random() > 0.25){
                const gate = this.spawnGate(this.lastElementZ);
                this.skillGates.push(gate);
            }
        }

        const skillGatesToDelete = [];
        this.skillGates.forEach(o => {
            o.moveTo(
                new Vector3(
                    o.boundingBox.position.x,
                    o.boundingBox.position.y,
                    o.boundingBox.position.z + amount
                )
            )
            if(o.boundingBox.position.z < -10){
                skillGatesToDelete.push(o);
            }
        })
        this.skillGates = this.skillGates.filter(o => !skillGatesToDelete.includes(o));
        skillGatesToDelete.forEach(o => {
            o.destroy();
        })
        //console.log(this.obstacles.length);
    }

    static getGates(){
        return this.skillGates;
    }

    static createSkillGate({position, blueprints}){
        return new Gate({
            scene: this.scene,
            blueprints,
            position,
        })
    }
}